import React, {Component, Fragment} from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import {DashboardBox4} from '../components';

class Dashboard4 extends Component {
	render() {
		const {pageTitle} = this.props;

		return (
			<Fragment>
				<Helmet title={pageTitle}/>
				<DashboardBox4/>
			</Fragment>
		);
	}
}

Dashboard4.defaultProps = {
	pageTitle: 'Dashboard'
};

Dashboard4.propTypes = {
	pageTitle: PropTypes.string
};

export default Dashboard4;